

























import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const ApplicationStore = namespace('application');

/**
 * Dialog which asks the users if he is still reading after a certain time of inactivity.
 */
@Component({})
export default class InactivityDialogComponent extends Vue {

    @ApplicationStore.Action('setInactivityTimer')
    private setInactivityTimer!: () => void;

    @ApplicationStore.Action('clearInactivityTimer')
    private clearInactivityTimer!: () => void;

    @ApplicationStore.Getter('inactivityDialog')
    private _inactivityDialog!: boolean;

    get inactivityDialog(): boolean {
        return this._inactivityDialog;
    }

    @ApplicationStore.Getter('inactivityConfirmed')
    private _inactivityConfirmed!: boolean;

    get inactivityConfirmed(): boolean {
        return this._inactivityConfirmed;
    }

    @Watch('inactivityConfirmed')
    private onInactivityConfirmedChange(currentValue: boolean, oldValue: boolean) {
        // this happens if the inactivity dialog is not used and the dialog timeout is triggered
        if (currentValue && !oldValue) {
            this.denyDialog();
        }
    }

    /**
     * Handles confirmation of inactivity dialog
     */
    public confirmDialog() {
        // restart the inactivity timer
        this.setInactivityTimer();
    }

    /**
     * Handles denial of inactivity dialog
     */
    public denyDialog() {
        this.clearInactivityTimer();
        this.$router.push({ name: 'library_view' });
    }
}
